import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { createChainStoreContract } from '../../api/chain-store-contract.ts';
import type { CreateChainStoreContractRequest } from '../../api/requests/chain-store-contract-request.ts';

export default function useCreateChainStoreContract(): UseMutationResult<
  string,
  Error,
  CreateChainStoreContractRequest
> {
  return useMutation({
    mutationFn: async (req) => {
      const response = await createChainStoreContract(req);
      return response.data.id;
    },
  });
}
